import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Axios from 'axios'
import moment from 'moment'
import VueSweetalert2 from 'vue-sweetalert2'
import vueNumeralFilterInstaller from 'vue-numeral-filter'
import Popover  from 'vue-js-popover'
import * as VueGoogleMaps from 'vue2-google-maps'
import VueI18n from 'vue-i18n'
import i18n from './i18n'

// -- Flags go here
////////////////
Vue.config.productionTip = false

// -- Components go here
////////////////
Vue.use(VueSweetalert2)
Vue.use(vueNumeralFilterInstaller)
Vue.use(Popover)
Vue.use(VueI18n)

// -- Filters
////////////////
moment.locale('es');

Vue.filter('to-date', function ( _date ) {
  if ( !_date ) return '';
  return moment( _date ).format( 'YYYY-MM-DD' );
});

Vue.filter('to-currency', function ( n ) {
  if ( !n || typeof n !== 'number' ) n = 0;
  return n.toLocaleString( 'es-MX', { style: 'currency', currency: 'MXN' } );
});

Vue.filter('to-currency-from-cents', function ( n ) {
  if ( !n || typeof n !== 'number' ) n = 0;
  return (n / 100).toLocaleString( 'es-MX', { style: 'currency', currency: 'MXN' } );
});

Vue.filter('get-date',function (n){
  let date = new Date(n).toLocaleDateString('zh-Hans-CN',{year:"numeric",month:"2-digit", day:"2-digit"}).replace(/\//g,'-')
  return date
});

Vue.filter('get-time',function (n){
  let date = new Date(n).toLocaleTimeString()
  return date
});

Vue.filter('capitalize', function (value) {
  if (!value) return '';
  value = value.toString().toLowerCase();
  return value.replace(/^[a-z]|\s[a-z]/g, s => s.toUpperCase())
});

// -- Additional setup
////////////////
Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyA5lyMwG4wTQWjs4AZ6L2m2bc56XPdSSdM',
    libraries: 'places'
  },
})

Vue.prototype.$http = Axios;
const token = localStorage.getItem('authToken');

if (token) {
  Axios.defaults.headers.common['Access-Control-Allow-Origin']= true;
  Axios.defaults.headers.common['Authorization'] = 'Bearer ' + token
}

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')


